<template>
    <div >
      <BaseModal
        v-if="visible"
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="'Add Scheduler Blocking Times'"
        :UseScroll="true"
        :width="'60%'"
        :height="'auto'"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.TitleOK'), variant: 'primary', action: onClick },
        ]"
        @Close="close"
        >
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                  v-bind:Label="$tc('Shared.Therapist')"
                  v-bind:Options="TherapistList"
                  v-bind:Model="employeeModel"
                  v-bind:FieldDescription="'employeeName'"
                  v-bind:FieldCode="'employeeCode'"
                  v-bind:Placeholder="selectPlaceholder"
                  v-bind:Multiple="false"
                  :isRequired="true"
                  v-bind:RequireEvent="true"
                  v-bind:IfUsevalidation="false"
                  :Input="ChangeDropDownTherapist"
                  :isValid="isValidTherapist"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$tc('Shared.AppointmentType')"
                    v-bind:Options="AppoinmentTypeList"
                    v-bind:Model="AppointmentTypeModel"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    v-bind:RequireEvent="true"
                    v-bind:IfUsevalidation="false"
                    :isRequired="false"
                    :Input="ChangeDropDownAppoinmentType"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('MdCurrentAppointment.StarTime')"
                    v-bind:TypeProp="'datetime-local'"
                    v-model="DateFrom"
                    v-bind:Id="'DateFrom'"
                    @input="DateFromChange"
                    :isRequired="true"
                    :isValid="isValidDateFrom"
                    :OnPressEnter="DateFromChange"
                    :@blur="DateFromChange"/>
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('MdCurrentAppointment.EndTime')"
                    v-bind:TypeProp="'time'"
                    v-model="endTime"
                    v-bind:Id="'Timeto'"
                    @input="DateToChange"
                    :isRequired="true"
                    :isValid="isValidDateTo"/>
            </b-col>

            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Shared.Status')"
                    v-bind:Options="StatusList"
                    v-bind:Model="statusModel"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:Placeholder="selectPlaceholder"
                    v-bind:Multiple="false"
                    :isRequired="true"
                    v-bind:IfUsevalidation="false"
                    :Input="ChangeDropDownStatus"
                    :isValid="isValidStatus"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit
                    v-bind:Label="$t('Shared.Description')"
                    v-bind:TypeProp="'text'"
                    v-bind:MaxLengthProp="255"
                    v-bind:Name="'description'"
                    v-model="data.description"
                    v-bind:Id="'Description'"
                />
            </b-col>
            <b-col md="6" lg="6" sm="12">
                <ejs-recurrenceeditor
                    ref="EditorObj"
                    :change="recurrenceChange"
                    :locale="locale"
                ></ejs-recurrenceeditor>
            </b-col>
        </b-row>

      </BaseModal>
     </div>
</template>

<script>
    import Vue from 'vue'
    import moment from 'moment'
    import CalendarResourcesService from '@/services/calendarresources.service'
    import AppoinmentTypeService from '@/services/appointmenttypes.service'
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import DBFunctions from '@/common/DBFunctions.js'
    import EnumService from '@/services/enum.service'
    import Permission from '@/common/Permission'
    import { RecurrenceEditorComponent } from '@syncfusion/ej2-vue-schedule';
    import CalendarResTimeAllocations from '@/services/calendarrestimeallocations.service';
    import Utils from '../../../common/utils'

    export default Vue.extend({
        name: "ModalScheduleBlockingTimesAdd",
        mixins: [ ShowMessage, DBFunctions, Permission ],
        components: {
            'ejs-recurrenceeditor': RecurrenceEditorComponent
        },
        props: {
          closeWindow: Function,
          visible: {
            type: Boolean,
            default: false
          },
        },
        data() {
            return {
                modalId: 'BlockingTimes',
                emitCloseEvent: false,

                fullParam: {
                    PageSize:0,
                    PageNumber:0
                },
                TherapistList:[],
                AppoinmentTypeList:[],

                selectPlaceholder: this.$t('Shared.SelectOptions'),
                DateFrom: moment(this.NewDate).format("YYYY-MM-DD"),
                isReadOnly: false,
                StatusList: EnumService.BlockingTimesStatus,
                locale: localStorage.language,
                employeeModel: null,
                AppointmentTypeModel: null,
                statusModel: null,
                endTime: null,
                data: {
                    Teamcode: null,
                    ApptType: null,
                    Datefrom: null,
                    Dateto: null,
                    Timefrom: null,
                    Timeto: null,
                    Status: null,
                    Description: null,
                    Recurrence: null
                },
                isValidTherapist: true,
                isValidDateFrom: true,
                isValidDateTo: true,
                isValidStatus: true

            }
        },
        watch: {
          visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
          },
        },
        methods: {

            onClick() {
                if (this.validation()) {
                    CalendarResTimeAllocations
                        .Add(this.data)
                        .then(response => {
                            if (response.status == '200') {
                                 if (this.visible) this.onHidden();
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
                } else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields') , "errorAutoHide");
                }
            },


            close() {
              this.emitEventCancel();
            },

            onHidden() {
                this.$emit('close');
                this.emitCloseEvent= false;
            },

            emitEventCancel() {
              this.emitCloseEvent= false;
              this.$emit('close');
            },

            validation() {
                this.isValidStatus = this.statusModel ? true : false
                this.isValidTherapist = this.employeeModel ? true : false
                this.isValidDateTo = Utils.isValidTime(this.endTime) ? true : false
                return this.isValidStatus && this.isValidTherapist && this.isValidDateTo
            },

            Save() {
                if (this.validation()) {
                    CalendarResTimeAllocations
                        .Add(this.data)
                        .then(response => {
                            if (response.status == '200') {
                                this.goBack()
                            }
                        })
                        .catch(error => {
                            this.showResponseErrorMessage(error);
                        });
                } else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields') , "errorAutoHide");
                }

            },

            goBack() {
                this.$router.push({ name: 'ScheduleBlockingTimesList' })
            },

            recurrenceChange: function(args) {
                this.data.Recurrence = args.value;
            },

            removeNeverEndOption() {
                const editor = this.$refs.EditorObj && this.$refs.EditorObj.ej2Instances;
                const endType = editor && editor.endType;
                if (endType) {
                    endType.dataSource = endType.dataSource.filter(item => item.value !== 'never');
                    if (endType.value === 'never') {
                        endType.value = 'until';
                    }
                    endType.dataBind();
                }
            },

            ChangeDropDownStatus(status) {
                this.isValidStatus = status ? true : false
                this.statusModel = status
                this.data.Status = status.value;
            },

            ChangeDropDownTherapist(therapists){
                this.isValidTherapist = therapists ? true : false
                this.employeeModel = therapists
                this.data.Teamcode = therapists.employeeCode;
            },

            ChangeDropDownAppoinmentType(appttypes){
                this.isValidApptype = appttypes ? true : false
                this.AppointmentTypeModel = appttypes
                this.data.ApptType = appttypes.code;
            },

            DateFromChange(){
                this.isValidDateFrom = Utils.isValidDate(this.DateFrom) ? true : false
                this.data.Timefrom = Utils.formatTime(this.DateFrom)
                this.data.Datefrom = Utils.formatterDate(this.DateFrom)
            },

            DateToChange(time){
                this.isValidDateTo = Utils.isValidTime(time) ? true : false
                this.data.Timeto = Utils.formatTime2(time)
                this.endTime = time
            },

            getEmployees() {
                CalendarResourcesService.getAll(this.fullParam)
                    .then((response) => {
                        if(response.status == '200' && response.data && response.data.length > 0){
                        this.TherapistList = response.data;
                        }
                    })
                    .catch(error => {
                        if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                        } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                        }
                    });
            },

            getAppointmentTypes() {
                AppoinmentTypeService.getListing()
                    .then((response) => {
                        if(response.status == '200' && response.data && response.data.length > 0){
                        this.AppoinmentTypeList = response.data;
                        }
                    })
                    .catch(error => {
                        if (!error.response) {
                        // network error
                        this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
                        } else {
                        this.showMessage(this.$tc('Msg.Error'),error,"error");
                        }
                    });
            },
        },

        async mounted () {
            this.getEmployees();
            this.getAppointmentTypes();

            this.data.Timefrom = Utils.formatTime(this.DateFrom)
            this.data.Datefrom = Utils.formatterDate(this.DateFrom)

            this.$nextTick(this.removeNeverEndOption);
        },
    })
</script>
<style>

</style>
